import { render } from "./TablaUbicacion.vue?vue&type=template&id=a75f9ffe&scoped=true"
import script from "./TablaUbicacion.vue?vue&type=script&lang=js"
export * from "./TablaUbicacion.vue?vue&type=script&lang=js"

import "./TablaUbicacion.vue?vue&type=style&index=0&id=a75f9ffe&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a75f9ffe"]])

export default __exports__